export const TEACHER_ROLE = "teacher";
export const USER_ROLE = "user";
export const ADMIN_ROLE = "admin";

export const TEACHER_WITH_ADMIN = [TEACHER_ROLE, ADMIN_ROLE];
export const USER_WITH_ADMIN = [USER_ROLE, ADMIN_ROLE];
